/** Admin: per-(org, capability) configuration. */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type { OrgCapabilityConfig } from '../types.js';

export function getOrgCapabilityConfig(
  organizationId: string,
  capabilityId: string,
): Promise<OrgCapabilityConfig> {
  return apiGet<OrgCapabilityConfig>(
    `/api/v1/admin/organizations/${organizationId}/capability-configs/${encodeURIComponent(capabilityId)}`,
  );
}

export function setOrgCapabilityConfig(
  organizationId: string,
  capabilityId: string,
  config: Record<string, unknown>,
): Promise<OrgCapabilityConfig> {
  return apiPut<OrgCapabilityConfig>(
    `/api/v1/admin/organizations/${organizationId}/capability-configs/${encodeURIComponent(capabilityId)}`,
    { config },
  );
}

export function deleteOrgCapabilityConfig(
  organizationId: string,
  capabilityId: string,
): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/organizations/${organizationId}/capability-configs/${encodeURIComponent(capabilityId)}`,
  );
}
